import qs from "query-string";
import { useMemo } from "react";

export const QueryRequestHelper = (props: any) => {
  let payload = { ...props };
  Object.keys(payload).forEach((key) => {
    if (!payload[key] || payload[key] === undefined) {
      delete payload[key];
    }
  });
  let queryRequest = qs.stringify(payload, {
    arrayFormat: "bracket",
    encode: true,
  });
  return queryRequest;
};

export const QueryRequestHelperWithoutEncode = (props: any) => {
  let payload = { ...props };
  Object.keys(payload).forEach((key) => {
    if (!payload[key] || payload[key] === undefined) {
      delete payload[key];
    }
  });
  let queryRequest = qs.stringify(payload, {
    arrayFormat: "bracket",
    encode: true,
  });
  return queryRequest;
};
export const QueryRequestHelperShowFalse = (props: any) => {
  let payload = { ...props };

  // Remove keys with null, undefined, or empty strings
  Object.keys(payload).forEach((key) => {
    if (payload[key] === null || payload[key] === undefined || payload[key] === "") {
      delete payload[key];
    }
  });

  let queryRequest = qs.stringify(payload, {
    arrayFormat: "bracket",
    encode: false,
  });

  return queryRequest;
};

export const QueryRequestHelperLegacyTask = (params: any) => {
  // Create a custom URLSearchParams that uses %20 for spaces
  const searchParams = new URLSearchParams();
  
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      // Convert value to string and ensure spaces are encoded as %20
      const stringValue = String(value).replace(/ /g, '%20');
      searchParams.append(key, stringValue);
    }
  });
  
  // Replace + with %20 in the final string
  return searchParams.toString().replace(/\+/g, '%20');
};
